<template>
    <div class="page-deliver-exc">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">珠海倉庫</div>
            <div class="breadcrumb-item">異常件</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline">
                <FormItem>
                    <Select size="small" placeholder="提貨櫃點" v-model="form.arrive">
                        <Option :value="item.ReceivingID" v-for="(item, index) in pickAddress"
                                :key="item.ReceivingID">({{item.cainiao_match}}) {{item.ReceivingName}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Select size="small" placeholder="業務類型" v-model="form.goods_type">
                        <Option :value="item.id" v-for="(item, index) in packageType"
                                :key="item.id">
                            {{item.describe}}
                        </Option>
                    </Select>
                </FormItem>
                <!-- <FormItem>
                    <Select size="small" placeholder="訂單類型">
                        <Option value="0">請選擇</Option>
                        <Option value="1">寄付</Option>
                        <Option value="2">到付</Option>
                        <Option value="3">代收</Option>
                    </Select>
                </FormItem> -->
                <FormItem>
                    <Select size="small" placeholder="收件方式" v-model="form.arrive_type">
                        <Option value="1">門店</Option>
                        <Option value="2">智能櫃</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Select size="small" placeholder="操作人" v-model="form.admin_id">
                        <Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                                :key="item.user_id">{{item.username}} ({{item.realname}})
                        </Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                placeholder="珠海入庫-開始日期" v-model="form.start_time" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>
                <FormItem>-</FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" :clearable="false"
                                placeholder="珠海入庫-結束日期" v-model="form.end_time" value-format="yyyy-MM-dd hh:mm:ss" :editable="false" style='width: 100%;'></DatePicker>
                </FormItem>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">快遞單號</label>
                    <Input size="small" v-model="form.odd_numbers" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">客戶名稱</label>
                    <Input size="small" v-model="form.recipient_contacts" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">客戶電話</label>
                    <Input size="small" v-model="form.phone" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <label class="input-label">袋號</label>
                    <Input size="small" v-model="form.sack_number" @keyup.enter.native="handleSearch()"></Input>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch">搜索</div>
                        <a  target="_blank" class="pg-btn style2" @click="handleExport" style="margin-left: 15px;">導出excel</a>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="arrive_type">
                    <!-- 取货方式 1:门店取货; 2:智能柜取货-->
                    <span v-if="row.arrive_type == 1">門店取貨</span>
                    <span v-else-if="row.arrive_type == 2">智能櫃取貨</span>
                </template>

                <template slot-scope="{ row, index }" slot="status">
                    <!-- 货物状态 0:待出库;1:已出库;2:配送中;3:代取件;4:已签收 -->
                    <span v-if="row.status == 0">待出库</span>
                    <span v-else-if="row.status == 1">已出庫</span>
                    <span v-else-if="row.status == 2">配送中</span>
                    <span v-else-if="row.status == 3">待取件</span>
                    <span v-else-if="row.status == 4">已簽收</span>
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
						<div class="pg-btn style3" @click="handleViewWuliu(index)">物流</div>
                        <div class="pg-btn style2" @click="handleEdit(index)" v-if="remarks == 1">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(index)" v-if="remarks == 1">刪除</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>

    </div>
</template>

<script>
	import Store from '../../../assets/js/store.js'
    export default {
        data()
        {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码
				pickAdmin: [],
                pickAddress: [],    //提貨櫃點
                packageType: [],    //包裹類型
				remarks: Store.fetch().type,
                form: {
                    arrive: '',    //提货柜点
                    arrive_type: '',    //收件方式，1门店，2智能柜
                    goods_type: '', //包裹类型
                    start_time: '',
                    end_time: '',
                    recipient_contacts: '', //客户名称
                    phone: '',  //客户手机号
                    odd_numbers: '',    //快递单号
                    sack_number: '',    //袋号
					admin_id: '',
                    status: ''
                },
				exportLink: '',
                isSubmiting: false,
                // isLoading: true,
                table: {
                    column: [
                        // {
                        //     type: 'selection',
                        //     minWidth: 60,
                        //     align: 'center',
                        // },
                        {
                            title: '客戶名稱',
                            key: 'recipient_contacts',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
						{
                            title: '客戶電話',
                            key: 'recipient_phone',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
                        // {
                        //     title: '添加時間',
                        //     key: 'created_at',
                        //     align: 'center',
                        //     minWidth: 160
                        // },
						{
						    title: '珠海入庫時間',
						    key: 'in_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160
						},
						{
						    title: '珠海出庫時間',
						    key: 'out_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160
						},
						{
						    title: '澳門入庫時間',
						    key: 'macao_originating_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160
						},
						{
						    title: '澳門出庫時間',
						    key: 'macao_originating_out_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160
						},
						{
						    title: '澳門門店上架時間',
						    key: 'arrive_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160
						},
						{
						    title: '澳門門店簽收時間',
						    key: 'pick_time',
						    align: 'center',
							sortable: true,
						    minWidth: 160
						},
						{
                            title: '操作人(珠海倉庫)',
                            key: 'actor',
                            align: 'center',
							sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '快遞單號',
                            key: 'odd_numbers',
                            align: 'center',
							sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '數量',
                            key: 'count',
                            align: 'center',
							sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '重量',
                            key: 'weight',
                            align: 'center',
							sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '泡重',
                            key: 'volume_weight',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                        // {
                            // title: '集貨倉庫',
                            // key: 'depository',
                            // align: 'center',
							// sortable: true,
                            // minWidth: 120
                        // },
                        {
                            title: '收件方式',
                            key: 'arrive_type',
                            align: 'center',
							slot: 'arrive_type',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '提貨櫃點',
                            key: 'receivingName',
                            align: 'center',
							sortable: true,
                            minWidth: 150
                        },
                        {
                            title: '出貨袋號',
                            key: 'sack_number',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
                        {
                            title: '異常原因',
                            key: 'reason',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
                        {
                            title: '異常處理',
                            key: 'handle',
                            align: 'center',
							sortable: true,
                            minWidth: 130
                        },
                        {
                            title: '貨物狀態',
                            key: 'status',
                            align: 'center',
							slot: 'status',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 200
                        }
                    ],
                    data: []
                }
            };
        },
        activated()
        {
            this.getPickAddress();
            this.getPackageType();
            this.getPickAdmin();  
        },
        mounted()
        {
            this.getPickAddress();
            this.getPackageType();
			this.getPickAdmin();  
        },
        methods: {
			handleViewWuliu(index)
			{
			    let tableData = this.table.data;
			    this.$router.push({path: '/ExclogisticsInfo?orderNo=' + tableData[index].odd_numbers});
			},
            handleEdit(index)
            {
                let tableData = this.table.data;
                this.$router.push({path: '/deliverExcEdit?id=' + tableData[index].id});
            },
            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.deliverDelete + '/' + tableData[index].id,
                            method: 'delete'
                        }).then((res) => {
                            this.isSubmiting = false;

                            if (res.code == 0) {
                                this.$Utils.showSuccess(res.msg);

                                if (tableData.length <= 1 && this.pageIndex > 1)
                                {
                                    this.pageIndex -= 1;
                                }

                                this.getList();

                            } else {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) => {
                            this.isSubmiting = false;
                        });
                    }
                });
            },
			//操作人
			getPickAdmin()
			{
			    this.$Rq.requestAuth({
			        url: this.$Api.pickAdmin,
			        method: 'post',
                    data: {
                        parent_id: 1,
                    }
			    }).then((res) =>
			    {
			        if (res.code == 0)
			        {
			            this.pickAdmin = res.data.data;
			        }
			    });
			},
            //提貨櫃點
            getPickAddress() {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 0,
                    }
                }).then((res) => {
					
                    if (res.code == 0) {
                        this.pickAddress = res.data.data.filter(it=>it.company_id != 15);;
						if (res.data.data.length <= 1) {
							this.form.arrive = res.data.data[0].ReceivingID
						}
						this.getList();
                    }
                });
            },
            //包裹類型
            getPackageType() {
                this.$Rq.requestAuth({
                    url: this.$Api.packageType,
                    method: 'get'
                }).then((res) => {
                    if (res.code == 0) {
                        this.packageType = res.data.data;
                    }
                });
            },
			formatDate(datetime)
			{
			    if (!datetime) return '';
			
			    let dateTime = new Date(datetime);
			    let year = dateTime.getFullYear();
			    let month = dateTime.getMonth() + 1;
			    let date = dateTime.getDate();
			    let hour = dateTime.getHours();
			    let minute = dateTime.getMinutes();
			    let second = dateTime.getSeconds();
				let milliseconds = dateTime.getMilliseconds();
			    return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
			},
			formatNum(num)
			{
			    return num < 10 ? '0' + num : num;
			},
            getList() {
                let form = this.form;
                // this.isLoading = true;
				this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.deliverExcList,
                    method: 'get',
                    data: {
                        abnormal: 1,
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        arrive: form.arrive,
                        arrive_type: form.arrive_type,
                        goods_type: form.goods_type,
                        start_time: this.formatDate(form.start_time),
                        end_time: this.formatDate(form.end_time),
                        recipient_contacts: form.recipient_contacts,
                        phone: form.phone,
                        odd_numbers: form.odd_numbers,
                        sack_number: form.sack_number,
						admin_id: form.admin_id,
                        status: ''
                    }
                }).then((res) => {
                    // this.isLoading = false;
					this.isSubmiting = false;
                    if (res.code == 0) {
                        let tempArr = [];
                        let resData = res.data.data;
                        for (let i = 0; i < resData.length; i++) {
                            tempArr.push({
                                id: resData[i].id,
                                recipient_contacts: resData[i].recipient_contacts,
								in_time: resData[i].in_time == null ? '- - -' : resData[i].in_time,
								out_time: resData[i].out_time == null ? '- - -' : resData[i].out_time,
								macao_originating_time: resData[i].macao_originating_time == null ? '- - -' : resData[i].macao_originating_time,
								macao_originating_out_time: resData[i].macao_originating_out_time == null ? '- - -' : resData[i].macao_originating_out_time,
								arrive_time: resData[i].arrive_time == null ? '- - -' : resData[i].arrive_time,
								pick_time: resData[i].pick_time == null ? '- - -' : resData[i].pick_time,
                                recipient_phone: resData[i].recipient_phone,
                                odd_numbers: resData[i].odd_numbers,
                                count: resData[i].count,
                                weight: resData[i].weight,
                                volume_weight: resData[i].volume_weight,
                                arrive_type: resData[i].arrive_type,
                                receivingName: resData[i].store ? resData[i].store.ReceivingName : '',
                                sack_number: resData[i].sack_number,
                                reason: resData[i].abnormal ? resData[i].abnormal.title: '',
                                handle: resData[i].remarks == null ? '- - -' : resData[i].remarks,
                                status: resData[i].status == null ? '- - -' : resData[i].status,
								actor: resData[i].admininfo == null ? '- - -' :resData[i].admininfo.realname
                            });
                        }

                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch((err) => {
					this.isSubmiting = false;
                    // this.isLoading = false;
                });
            },

            handleSearch() {
                this.pageIndex = 1;
                this.getList();
            },
			handleExport()
			{
			    let token = localStorage.getItem('jyb_token');
			    let form = this.form;
			    let params = {
			        'Authorization': token,
			        abnormal: 1,  //0待出库, 1已出库
			        arrive: form.arrive,
			        arrive_type: form.arrive_type,
			        goods_type: form.goods_type,
			        start_time: this.formatDate(form.start_time),
			        end_time: this.formatDate(form.end_time),
			        recipient_contacts: form.recipient_contacts,
			        phone: form.phone,
			        odd_numbers: form.odd_numbers,
			        sack_number: form.sack_number,
					admin_id: form.admin_id
			    };
			    let formatParams = this.$Utils.formateObjToParamStr(params);
				
				if(form.start_time == ''){
					this.$Utils.showTipInfo("請選擇珠海入庫起始時間");
				}
				else if(form.end_time == ''){
					this.$Utils.showTipInfo("請選擇珠海入庫结束時間");
				}
				else{
                    this.getList();
					// window.open(`${this.$Api.deliverExport}?${formatParams}`, '_blank');
					window.open(`${this.$Api.deliverExport_old}?${formatParams}`, '_blank');
					// this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
				}
			    // window.open(`${this.$Api.deliverExport}?${formatParams}`, '_blank');
			},
            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "DeliverExc.scss";
</style>